export enum ReviewListType {
  REVIEWS = 'reviews',
  SAVED_PLACES = 'saved-places',
}
